<template>
    <div class="developer-chapter-base" id="developer">
        <div class="container">
            <div class="inner row">
                <div class="col-xs-12 content text-center" id="we-hire">
                    <p><span>H5开发团队面临着一系列深度技术挑战，同时又涉及非常广泛的技术方向，不论你是职业程序员，还是最近才接触编程的新手，都可以为H5开发做出贡献。</span></p>
                    <a href="https://github.com/ckcz123/mota-js">
                        <p class="link">访问github主页 <a-icon type="right"></a-icon></p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.developer-chapter-base {
    margin-top: 130px;
    background: rgba(255, 255, 255, 0);
    /* For browsers that do not support gradients */
    background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(rgba(255, 255, 255, 0)));
    background: -o-linear-gradient(#ffffff, rgba(255, 255, 255, 0));
    background: linear-gradient(#ffffff, rgba(255, 255, 255, 0));
    /* Standard syntax */
    > .container > .inner {
        margin-top: -45px;
    }
    #we-hire {
        padding-bottom: 60px;
    }
    #we-hire > p:first-child {
        padding-top: 80px;
        padding-left: 10px;
        padding-right: 10px;
        border-top: 1px solid #dddddd;
    }
}
</style>